<template>
  <div class="app-container">
    <!--工具栏-->
    <div class="head-container">
      <!-- 新增 -->

      <el-select
        class="filter-item"
        v-model="tableIndex"
        placeholder="表格"
        style="width: 300px"
        @change="tableChange"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        class="filter-item"
        clearable
        v-model="speciesId"
        placeholder="种类"
        style="width: 150px"
      >
        <el-option
          v-for="item in options1"
          :key="item.id"
          :label="item.speciesName"
          :value="item.id"
        >
        </el-option>
      </el-select>

      <el-select
        class="filter-item"
        v-model="subjectId"
        clearable
        placeholder="科目"
        style="width: 150px"
      >
        <el-option
          v-for="item in options3"
          :key="item.subjectId"
          :label="item.subjectName"
          :value="item.subjectId"
        >
        </el-option>
      </el-select>

      <el-select
        class="filter-item"
        v-model="type"
        clearable
        placeholder="类型"
        style="width: 150px"
      >
        <el-option
          v-for="item in open"
          :key="item.id"
          :label="item.val"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button
        class="filter-item"
        size="mini"
        type="success"
        icon="el-icon-search"
        @click="search"
        >搜索
      </el-button>
      <el-button
        class="filter-item"
        size="mini"
        type="primary"
        icon="el-icon-plus"
        @click="add"
        >新增
      </el-button>
    </div>
    <!--表单组件-->
    <form1 v-if="tableIndex === 1" ref="form1" :is-add="isAdd" />
    <form2 v-if="tableIndex === 2" ref="form2" :is-add="isAdd" />
    <!--表格渲染-->

    <!-- 表格1 start -->
    <table1 v-if="tableIndex === 1" ref="table1" :selectFlag="selectFlag" @selectOver="selectOver" />
    <table2 v-if="tableIndex === 2" ref="table2" :selectFlag="selectFlag" @selectOver="selectOver" />
    <!-- 表格1 end -->
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import initData from "@/mixins/initData";
import { getTableFullType, delTable } from "@/api/table";
import { parseTime } from "@/utils/index";
import form1 from "./component/table1/form.vue";
import table1 from "./component/table1/index.vue";
import form2 from "./component/table2/form.vue";
import table2 from "./component/table2/index.vue";
import { getSpecies } from "@/api/species";
import { getTopic } from "@/api/topic";
import { getSubjectFull } from "@/api/teacher";

export default {
  components: { form1, table1, form2, table2 },
  mixins: [initData],
  data() {
    return {
      type:null,//类型
      selectFlag: false,
      selectArr: {},
      delLoading: false,
      tableIndex: 0,
      options: [],
      options1: [],
      options2: [],
      options3: [],
      open: [
        {
          id: 1,
          val: "技术",
        },
        {
          id: 2,
          val: "健康",
        },
        {
          id: 3,
          val: "地球",
        },
        {
          id: 4,
          val: "科学",
        },
        {
          id: 5,
          val: "心理",
        },
        {
          id: 6,
          val: "太空",
        },
      ],

      speciesId: "",
      subjectId: "",

      forMap: {
        1: "form1",
        2: "form2",
        3: "form3",
      },
      tableMap: {
        1: "table1",
        2: "table2",
        3: "table3",
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    checkPermission,
    selectOver(arr) {
      this.selectArr = arr
    },
    beforeInit() {
      this.url = "api/table/" + this.tableIndex;
      const sort = "id,desc";
      this.params = { page: this.page, size: this.size, sort: sort };
      return true;
    },
    subDelete(id) {
      this.delLoading = true;
      delTable(this.tableIndex, id)
        .then((res) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleChangePage();
          this.init();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500,
          });
        })
        .catch((err) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err.response.data.message);
        });
    },
    add() {
      let _this = this.$refs[this.tableMap[this.tableIndex]];
      _this.add()
    },

    tableUpdate() {
      let _this = this.$refs[this.tableMap[this.tableIndex]];
      _this.init();
    },
    search() {
      let _this = this.$refs[this.tableMap[this.tableIndex]];
      _this.speciesId = this.speciesId;
      _this.subjectId = this.subjectId;
      _this.type = this.type;
      console.log(_this);
      _this.toQuery();
    },
    tableChange(num) {
      this.tableIndex = num;
      setTimeout(() => {
        let _this = this.$refs[this.tableMap[this.tableIndex]];
        _this.options1 = this.options1;
        _this.options2 = this.options2;
        _this.options3 = this.options3;
        _this.speciesId = this.speciesId;
        _this.subjectId = this.subjectId;
        _this.selectArr = this.selectArr
      }, 200);
    },
  },
  beforeMount() {
    Promise.all([
      getTableFullType(),
      getSpecies(),
      getTopic(),
      getSubjectFull(),
    ]).then((e) => {
      //获取表格
      this.options = e[0];
      //获取种类
      this.options1 = e[1].content;
      //获取话题
      this.options2 = e[2].content;
      //获取科目
      this.options3 = e[3];
      this.tableChange(1);
    });
  },
};
</script>

<style scoped>
</style>
